<template>
  <div>
    <div v-if="!just_select_product" style="background-color: #f6f6f6; padding-top: 10px" :id="id">
      <el-row>
        <el-col :sm="12">
          <p style="font-size: 15px; color: #9999a6">{{ $t('base.mass_edit') }}
            &nbsp;&nbsp;<span style="color: #000000">{{ $t('base.selected') }} <span style="color: orangered;">0</span>
              {{ $t('base.variations') }}</span>
          </p>
        </el-col>
        <el-col :sm="12" class="text-right" style="padding-right: 5px">
          <el-button v-if="save_current_product" type="primary" size="mini"
                     :disabled="!product_selected_list.length" @click="m__show_create_flash_sale_filename_dialog">
            {{ $t('flash_sale.save_products_to_file') }}
          </el-button>
        </el-col>
      </el-row>
      <table class="table table-no-border" style="margin-top: 20px">
        <tr>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6"> {{ $t('base.discount') }}
                {{
                  form_update.discount_type === 'percent' ? `(% ${$t('flash_sale.discount')})` : `(${$t('base.amount')})`
                }}</small>
              <el-input size="mini" type="number" v-model="form_update.discount_value"></el-input>
            </div>
          </td>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6">{{ $t('base.edit_type') }}</small>
              <el-select size="mini" v-model="form_update.discount_type">
                <el-option value="percent" :label="`% ${$t('flash_sale.discount')}`"></el-option>
                <el-option value="reduce" :label="$t('flash_sale.reduce_by_amount')"></el-option>
                <el-option value="cash" :label="$t('flash_sale.set_by_amount')"></el-option>
              </el-select>
            </div>
          </td>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6">{{ $t('flash_sale.campaign_stock') }}</small>
              <el-input size="mini" type="number" v-model="form_update.quantity"></el-input>
            </div>
          </td>
          <td style="width: 19%">
            <div style="padding: 0 15px 0 5px">
              <small style="color: #9999a6">{{ $t('flash_sale.purchase_limit') }}</small><br>
              <el-select size="mini" value="" class="full-w" v-model="form_update.limit">
                <el-option :label="$t('base.unlimited')" :value="0"></el-option>
                <el-option :label="$t('base.limited')" :value="1"></el-option>
              </el-select>
              <br>
            </div>
          </td>
          <td style="width: 40%">
            <small>&nbsp;</small><br>
            <el-button size="mini" type="primary" @click="m__update_multiple(false)">
              {{ $t('base.update_all') }}
            </el-button>
            <el-button size="mini" type="primary" v-bind:disabled="m__can_update_multiple()"
                       @click="m__update_multiple(true)">{{ $t('base.update_selected') }}
            </el-button>
            <el-button v-if="show_enable" size="mini" type="primary" :loading="loading.mass_enable"
                       @click="m__mass_enable_models()">{{ $t('base.mass_enable') }}
            </el-button>
          </td>
        </tr>
        <tr>
          <td style="width: 15%">
          </td>
          <td style="width: 13%">
          </td>
          <td style="width: 13%">
          </td>
          <td style="width: 19%">
            <div style="padding: 5px 15px 0 5px">
              <el-input v-if="form_update.limit === 1" type="number" size="mini" style="width: 100%"
                        v-model="form_update.limit_value"></el-input>
            </div>
          </td>
          <td style="width: 40%">
          </td>
        </tr>
      </table>
    </div>
    <div v-if="!just_select_product" style="background-color: #f6f6f6;" :id="`${id}-fixed`" class="sticky-hide">
      <table class="table table-no-border" style="margin: 10px 0">
        <tr>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6"> {{ $t('base.discount') }}
                {{
                  form_update.discount_type === 'percent' ? `(% ${$t('flash_sale.discount')})` : `(${$t('base.amount')})`
                }}</small>
              <el-input size="mini" type="number" v-model="form_update.discount_value"></el-input>
            </div>
          </td>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6">{{ $t('base.edit_type') }}</small>
              <el-select size="mini" v-model="form_update.discount_type">
                <el-option value="percent" :label="`% ${$t('flash_sale.discount')}`"></el-option>
                <el-option value="reduce" :label="$t('flash_sale.reduce_by_amount')"></el-option>
                <el-option value="cash" :label="$t('flash_sale.set_by_amount')"></el-option>
              </el-select>
            </div>
          </td>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6">{{ $t('flash_sale.campaign_stock') }}</small>
              <el-input size="mini" type="number" v-model="form_update.quantity"></el-input>
            </div>
          </td>
          <td style="width: 19%">
            <div style="padding: 0 15px 0 5px">
              <small style="color: #9999a6">{{ $t('flash_sale.purchase_limit') }}</small><br>
              <el-select size="mini" value="" class="full-w" v-model="form_update.limit">
                <el-option :label="$t('base.unlimited')" :value="0"></el-option>
                <el-option :label="$t('base.limited')" :value="1"></el-option>
              </el-select>
              <br>
            </div>
          </td>
          <td style="width: 40%">
            <small>&nbsp;</small><br>
            <el-button size="mini" type="primary" @click="m__update_multiple(false)">{{
                $t('base.mass_update')
              }}
            </el-button>
            <el-button size="mini" type="primary" v-bind:disabled="m__can_update_multiple()"
                       @click="m__update_multiple(true)">{{ $t('base.update_selected') }}
            </el-button>
            <el-button v-if="show_enable" size="mini" type="primary" :loading="loading.mass_enable"
                       @click="m__mass_enable_models()">{{ $t('base.mass_enable') }}
            </el-button>
          </td>
        </tr>
        <tr>
          <td style="width: 15%">
          </td>
          <td style="width: 13%">
          </td>
          <td style="width: 13%">
          </td>
          <td style="width: 19%">
            <div style="padding: 5px 15px 0 5px">
              <el-input v-if="form_update.limit === 1" type="number" size="mini" style="width: 100%"
                        v-model="form_update.limit_value"></el-input>
            </div>
          </td>
          <td style="width: 40%">
          </td>
        </tr>
      </table>
    </div>

    <div style="margin-top: 15px">
      <el-row>
        <el-col :sm="12">
          <el-pagination
            :current-page.sync="page_filter.current_page" :page-size="page_filter.page_size"
            layout="prev, pager, next, total" :total="c__product_selected_filter_list.length"/>
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-input size="mini" :placeholder="$t('input.placeholder')" style="max-width: 250px;"
                    prefix-icon="el-icon-search" v-model="page_filter.input_keyword" clearable/>
        </el-col>
      </el-row>
    </div>

    <div style="margin-top: 15px">
      <table class="table table-no-border">
        <thead>
        <tr style="background-color: #f5f5f5">
          <th style="width: 50px">
            <el-checkbox v-model="model_is_select_all" size="mini" @change="m__model_select_all_change"></el-checkbox>
          </th>
          <th style="min-width: 200px">{{ $t('base.variation') }}</th>
          <th style="width: 190px">
            {{ $t('base.variation_price') }}
            <div>
              <el-dropdown trigger="click">
                <strong v-if="price_type === 'original'" class="text-primary">
                  {{ $t('flash_sale.using_original_price') }}
                </strong>
                <strong v-if="price_type === 'current'" class="text-primary">
                  {{ $t('flash_sale.using_discount_price') }}
                </strong>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="price_type = 'original'">
                    {{ $t('flash_sale.use_original_price') }}
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="price_type = 'current'">
                    {{ $t('flash_sale.use_discount_price') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </th>
          <th>{{ $t('base.discounted_price') }}</th>
          <th></th>
          <th>{{ $t('base.discount') }}</th>
          <th>{{ $t('flash_sale.campaign_stock') }}</th>
          <th>{{ $t('base.stock') }}</th>
          <th>{{ $t('flash_sale.purchase_limit') }}</th>
          <th v-if="show_enable">{{ $t('flash_sale.enable_disable') }}</th>
          <th>
            <template v-if="product_selected_list.length">
              <el-button type="text" size="mini" @click="m__remove_all_products()">
                <strong class="text-danger">
                  {{ $t('base.delete_x', {x: $t('base.all')}) }}
                </strong>
              </el-button>
            </template>
            <template v-else>
              {{ $t('base.action') }}
            </template>
          </th>
        </tr>
        </thead>
        <template v-if="get_data">
          <tr>
            <td style="text-align: center;" colspan="11">
              <div style="padding-top: 20px">
                <i class="el-icon-loading"></i><strong> {{ $t('base.loading_data') }}</strong>
              </div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tbody>
          <tr>
            <td>
              <div style="height: 5px;"></div>
            </td>
          </tr>
          <template v-for="item in c__product_selected_display_list">
            <tr style="background-color: #f6f6f6; padding-top: 5px">
              <td>
                &nbsp;&nbsp;<el-checkbox size="mini" v-model="item.checked"
                                         @change="m__check_product(item)"></el-checkbox>
              </td>
              <td colspan="7">
                <!--                <div style="display: flex; align-items: center; gap: 8px">
                                  <img :src="SHOPEE_IMAGE(item.product.images.split(',')[0])" alt="logo"
                                       style="width: 28px; height: 28px;">
                                  <div>
                                    <span>
                                      SKU: {{ item.product.sku }} - {{ $t('base.code') }}: {{ item.product.itemid }}
                                    </span>
                                    <br>
                                    <a href="javascript:void(0)"
                                       @click="open_link_fixed(`https://shopee.com/product-i.${shopee_id}.${item.product.itemid}`, shop)">
                                      {{ item.product.name }}
                                    </a>
                                  </div>
                                </div>-->
                <div style="display: flex; align-items: center; gap: 8px">
                  <img :src="SHOPEE_IMAGE(item.product.images.split(',')[0])" alt="logo"
                       style="width:25px; height: 25px;">
                  <div>
                    <a href="javascript:void(0)"
                       @click="open_link_fixed(`https://shopee.com/product-i.${shopee_id}.${item.product.itemid}`, shop)">
                      {{ item.product.itemid }} - {{ item.product.name }}
                    </a>
                  </div>
                </div>
              </td>
              <td>
                <el-select size="mini" value="" v-model="item.product.limit" :disabled="item.product.enable"
                           style="width: 130px;">
                  <el-option :label="$t('base.unlimited')" :value="0"></el-option>
                  <el-option :label="$t('base.limited')" :value="1"></el-option>
                </el-select>
              </td>
              <td v-if="show_enable" style="text-align: center">
                <el-switch v-if="item.model_list.length > 1" size="mini" v-model="item.product.enable"
                           @change="m__product_enable_change(item)"></el-switch>
              </td>
              <td style="text-align: center;">
                <el-button size="small" type="danger" icon="el-icon-delete" @click="m__remove_product(item)"
                           circle></el-button>
              </td>
            </tr>
            <tr>
              <td>
                <div style="height: 5px"></div>
              </td>
            </tr>
            <template v-for="model in m__sort_model_list(item.model_list)">
              <tr :class="model.stock < 1 ? 'disabled-text' : ''">
                <td>
                  &nbsp;&nbsp;<el-checkbox size="mini" :disabled="model.stock < 1 || model.enable"
                                           v-model="model.checked"
                                           @change="m__model_item_checked_change"></el-checkbox>
                </td>
                <td style="width: 130px">
                  <div style="line-height: 20px">
                    <span style="font-weight: 600">{{ model.name || '-' }}</span>
                    <br>
                    <span style="font-size: 11px !important;" class="text-warning">
                      SKU: {{ model.sku || '-' }}
                    </span>
                    <br>
                    <span style="font-size: 11px !important;" class="text-warning">
                      {{ $t('base.id') }}: {{ model.modelid }}
                    </span>
                  </div>
                </td>
                <td>
                  <div style="display: flex; gap: 10px; align-items: center">
                    <div style="line-height: 20px">
                      <span style="font-weight: 500">
                        {{ model.price | currency }}
                      </span>
                      <template v-if="+model.promotionPrice">
                        <br>
                        <span style="font-size: 11px !important;" class="text-warning">
                          {{ model.promotionPrice | currency }}
                        </span>
                      </template>
                    </div>
                    <div v-if="(is_create_component || is_edit_component) && model.enable && model.misleading"
                         style="width: 10px; padding-top: 1px">
                      <el-tooltip class="item" effect="light"
                                  placement="top">
                        <i class="el-icon-warning" style="font-size: 15px; color: #989898"></i>
                        <div slot="content" style="padding: 3px">
                          {{ $t('flash_sale.this_may_violate') }}
                          <a href="https://banhang.shopee.vn/edu/article/268/" target="_blank">
                            {{ $t('flash_sale.misleading_policy') }}
                          </a>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </td>
                <td style="width: 100px">
                  <el-input type="number" size="mini" :disabled="model.stock < 1 || model.enable"
                            @input="m__model_update_discount_price(item, model)"
                            v-model="model.discount_price" :min="1000" :max="model.price"></el-input>
                </td>
                <td style="text-align: center">
                  {{ $t('base.or') }} (%)
                </td>
                <td style="width: 100px">
                  <el-input type="number" size="mini" :disabled="model.stock < 1 || model.enable"
                            @input="m__model_update_discount_percent(item, model)"
                            v-model="model.discount_percent" :min="5" :max="90"
                            :class="m__show_high_discount_warning(model.discount_percent)"></el-input>
                </td>
                <td style="width: 130px; padding-left: 15px">
                  <el-input type="number" size="mini" :disabled="model.stock < 1 || model.enable"
                            v-model="model.quantity" :min="1" :max="model.stock"></el-input>
                </td>
                <td style="padding-left: 10px !important;">
                  {{ model.stock | currency }}
                </td>
                <td style="width: 150px">
                  <template v-if="item.product.limit === 0">
                    {{ $t('base.unlimited') }}
                  </template>
                  <template v-if="item.product.limit === 1">
                    <el-input size="mini" type="number" :min="1" v-model="item.product.limit_value"
                              :disabled="model.stock < 1 || model.enable" style="width: 130px;"></el-input>
                  </template>
                </td>
                <td style="text-align: center" v-if="show_enable">
                  <el-switch size="mini" :disabled="+model.stock < 1" v-model="model.enable"
                             @change="m__model_enable_change(item, model)"></el-switch>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td colspan="11">
                  <span v-if="model.error_message" class="text-danger" v-html="`${ model.error_message }`"></span>
                </td>
              </tr>
            </template>
            <tr>
              <td>
                <div style="height: 5px;"></div>
              </td>
            </tr>
          </template>
          </tbody>
        </template>
      </table>
    </div>

    <div style="margin-top: 15px">
      <el-row>
        <el-col :sm="12">
          <el-pagination
            :current-page.sync="page_filter.current_page" :page-size="page_filter.page_size"
            layout="prev, pager, next, total" :total="c__product_selected_filter_list.length"/>
        </el-col>
        <el-col :sm="12">
        </el-col>
      </el-row>
    </div>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.create_flash_sale_filename"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input v-model="filename" size="mini" :placeholder="$t('input.filename')"></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" @click="m__create_flash_sale_file" icon="el-icon-check"
                     :loading="loading.create_flash_sale_file"> {{ $t('flash_sale.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  drop as _drop,
  take as _take,
  orderBy as _orderBy
} from 'lodash'
import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'component_flash_sale_product',

  mixins: [fix_ads_mixins],

  props: {
    id: {
      type: String,
      default: 'stick'
    },
    seller: {
      type: Object,
      default: {}
    },
    product_selected_list: {
      type: Array,
      default: []
    },
    flash_sale_created: {
      type: Array,
      default: []
    },
    is_create_component: {
      type: Boolean,
      default: false
    },
    is_edit_component: {
      type: Boolean,
      default: false
    },
    save_current_product: {
      type: Boolean,
      default: true
    },
    flash_sale: {
      type: Object,
      default: null
    },
    shop_id: {
      type: String,
      default: ''
    },
    shopee_id: {
      type: String,
      default: ''
    },
    show_enable: {
      type: Boolean,
      default: true
    },
    get_data: {
      type: Boolean,
      default: false
    },
    just_select_product: {
      type: Boolean,
      default: false
    },
    parent_scroll_id: {
      type: String,
      default: '#dashboard-wrapper'
    },
    shop: null
  },

  data() {
    return {
      model_is_select_all: false,
      form_update: {
        discount_type: 'percent',
        discount_value: null,
        discount_percent: null,
        quantity: null,
        limit: 0,
        limit_value: null
      },
      sticky_block: null,
      filename: '',
      show_dialog: {
        create_flash_sale_filename: false
      },
      loading: {
        create_flash_sale_file: false,
        mass_enable: false
      },
      page_filter: {
        page_size: 10,
        current_page: 0,
        input_keyword: ''
      },
      price_type: 'original',
      sticky_block_offset: null
    }
  },

  watch: {
    'product_selected_list': function () {
      // this.m__get_product_detail()
      this.m__get_sticky_block_offset()
    }
  },

  mounted() {
    // this.m__get_sticky_block_offset()
  },

  beforeDestroy() {
    const parent_scroll = document.querySelector(this.parent_scroll_id)
    if (parent_scroll) parent_scroll.removeEventListener('scroll', this.m__handle_scroll)
  },

  computed: {
    c__product_selected_filter_list() {
      // const keyword = this.remove_unicode(this.page_filter.input_keyword)
      // return this.product_selected_list.filter(i => this.remove_unicode(JSON.stringify(i)).includes(this.remove_unicode(keyword)))

      const words = this.remove_unicode(this.page_filter.input_keyword).split(',')
      const pattern = words.map(w => this.escape_regex(w)).join('|');
      const regex = new RegExp(pattern);

      return this.product_selected_list.filter(item => {
        const string = this.remove_unicode(JSON.stringify(item))
        return regex.test(string)
      })
    },

    c__product_selected_display_list() {
      const limit = this.page_filter.page_size
      const skip = limit * (this.page_filter.current_page - 1)
      return _take(_drop(this.c__product_selected_filter_list, skip), limit)
    }
  },

  methods: {
    m__get_sticky_block_offset() {
      this.$nextTick(() => {
        this.sticky_block = document.getElementById(`${this.id}-fixed`)
        const main_block = document.getElementById(this.id)
        if (main_block) {
          this.sticky_block_offset = main_block.offsetTop + main_block.clientHeight
          document.querySelector(this.parent_scroll_id).addEventListener('scroll', this.m__handle_scroll)
        }
      })
    },

    // async m__enable_multiple() {
    //   this.loading.mass_enable = true
    //   for (const item of this.product_selected_list) {
    //     item.product.enable = true
    //     await this.m__product_enable_change(item)
    //     item.product.enable = item.model_list.length === item.model_list.filter(i => i.enable).length
    //     await this.sleep(500)
    //   }
    //   this.loading.mass_enable = false
    // },

    async m__mass_enable_models() {
      this.loading.mass_enable = true

      try {
        for (const item of this.product_selected_list) {
          item.product.enable = true

          for (const model of item.model_list) {
            if (model.stock > 0) {
              model.enable = true
              if (model.discount_percent > 90 || model.discount_percent < 5) {
                model.error_message = this.$t('flash_sale.discount_percent_between_x_y', {
                  x: '5',
                  y: '90'
                })
                model.enable = false
                item.product.enable = false
                continue
              }

              if (model.quantity < 1 || model.quantity > model.stock) {
                model.error_message = this.$t('flash_sale.promotion_quantity_between_x_y', {
                  x: '1',
                  Y: model.stock
                })
                model.enable = false
                item.product.enable = false
                continue
              }

              if (model.quantity > 1000) {
                model.error_message = this.$t('flash_sale.promotion_quantity_lt_x', {x: '1000'})
                model.enable = false
                item.product.enable = false
                continue
              }

              if (model.quantity * this.flash_sale_created.length > model.stock) {
                model.error_message = this.$t('flash_sale.evenly_every_days')
                model.enable = false
                item.product.enable = false
                continue
              }

              if (model.enable) {
                model.error_message = ''
              }

              if (this.is_edit_component) {
                model.error_message = ''
              }
            } else {
              model.enable = false
            }
          }

          item.product.enable = item.model_list.length === item.model_list.filter(i => i.enable).length
        }

        if (this.is_edit_component) {
          await this.m__save_and_apply()
        }
      } catch (e) {
        console.error(e)
      }

      this.loading.mass_enable = false
    },

    m__sort_model_list(model_list) {
      return _orderBy(model_list, ['name'], ['asc'])
    },

    m__show_high_discount_warning(discount) {
      if (discount >= 50) {
        return 'text-warning-level-1'
      }
      // if (discount >= 40) {
      //   return 'text-warning-level-2'
      // }
    },

    async m__get_product_detail() {
      if (!this.seller || !this.product_selected_list.length) return

      const response = await this.seller.get_product_by_graphql(this.product_selected_list.map(i => i.product.itemid.toString()))
      if (response.data && response.data.products && response.data.products.items) {
        for (const item of response.data.products.items) {
          const product_found = this.product_selected_list.find(i => i.product.itemid === +item.itemid)
          if (!product_found) continue

          for (const model of item.modelList) {
            const model_found = product_found.model_list.find(i => i.modelid === +model.modelid)
            if (model_found) model_found.name = model.name
          }
        }
      }
    },

    m__handle_scroll() {
      // if (!this.save_current_product) {
      //   return
      // }

      if (document.querySelector(this.parent_scroll_id).scrollTop > this.sticky_block_offset) {
        this.sticky_block.classList.remove('sticky-hide')
        this.sticky_block.classList.add('sticky')
      } else {
        this.sticky_block.classList.remove('sticky')
        this.sticky_block.classList.add('sticky-hide')
      }
    },

    m__can_update_multiple() {
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (model.checked) {
            return false
          }
        }
      }
      return true
    },

    m__update_multiple(selected = false) {
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (!selected && model.stock > 0 && !model.enable) {
            if (this.form_update.limit === 0 || (this.form_update.limit === 1 && this.form_update.limit_value)) {
              item.product.limit = this.form_update.limit
              item.product.limit_value = this.form_update.limit_value
            }

            if (this.form_update.discount_type === 'percent' && this.form_update.discount_value) {
              model.discount_percent = +this.form_update.discount_value
              this.m__model_update_discount_percent(item, model)
            }
            if (this.form_update.discount_type === 'reduce' && this.form_update.discount_value) {
              const price = this.price_type === 'original' ? model.price : (model.promotionPrice || model.price)
              model.discount_price = price - +this.form_update.discount_value
              this.m__model_update_discount_price(item, model)
            }
            if (this.form_update.discount_type === 'cash' && this.form_update.discount_value) {
              model.discount_price = +this.form_update.discount_value
              this.m__model_update_discount_price(item, model)
            }

            if (this.form_update.quantity) {
              model.quantity = this.form_update.quantity <= model.stock ? this.form_update.quantity : model.stock
            }
          }

          if (selected && model.checked && model.stock > 0 && !model.enable) {
            if (this.form_update.limit && this.form_update.limit_value) {
              item.product.limit = this.form_update.limit
              item.product.limit_value = this.form_update.limit_value
            }

            if (this.form_update.discount_type === 'percent' && this.form_update.discount_value) {
              model.discount_percent = this.form_update.discount_value
              this.m__model_update_discount_percent(item, model)
            }
            if (this.form_update.discount_type === 'reduce' && this.form_update.discount_value) {
              const price = this.price_type === 'original' ? model.price : (model.promotionPrice || model.price)
              model.discount_price = price - +this.form_update.discount_value
              this.m__model_update_discount_price(item, model)
            }
            if (this.form_update.discount_type === 'cash' && this.form_update.discount_value) {
              model.discount_price = this.form_update.discount_value
              this.m__model_update_discount_price(item, model)
            }

            if (this.form_update.quantity) {
              model.quantity = this.form_update.quantity <= model.stock ? this.form_update.quantity : model.stock
            }
          }
        }
      }
    },

    m__model_select_all_change() {
      this.product_selected_list.forEach(i => {
        i.checked = this.model_is_select_all
        i.model_list.forEach(ii => ii.checked = this.model_is_select_all)
      })
    },

    m__check_product(product) {
      if (product.checked) {
        product.model_list.forEach(ii => ii.checked = true)
      } else {
        product.model_list.forEach(ii => ii.checked = false)
      }

      this.m__model_item_checked_change()
    },

    m__model_item_checked_change() {
      for (const item of this.product_selected_list) {
        const checked_number = item.model_list.reduce((total, model) => {
          if (model.checked) total++
          return total
        }, 0)
        item.checked = item.model_list.length === checked_number
      }

      const checked_number = this.product_selected_list.reduce((result, item) => {
        result[0] += item.model_list.length
        result[1] += item.model_list.filter(i => i.checked).length
        return result
      }, [0, 0])

      this.model_is_select_all = checked_number[0] === checked_number[1]
    },

    async m__remove_all_products() {
      this.$emit('m__remove_product', null)
    },

    async m__remove_product(item) {
      this.$emit('m__remove_product', item)
    },

    async m__product_enable_change(item) {
      if (item.product.enable) {
        for (const model of item.model_list) {
          if (model.stock > 0) {
            model.enable = true
            await this.m__model_enable_change(item, model)
          } else {
            model.enable = false
          }
        }
      } else {
        item.model_list.forEach(i => i.enable = false)
      }

      await this.sleep(200)
    },

    m__model_update_discount_percent(item, model) {
      if (model.discount_percent > 100) {
        model.discount_percent = 100
      } else if (model.discount_percent < 0) {
        model.discount_percent = 0
      }

      const price = this.price_type === 'original' ? model.price : (model.promotionPrice || model.price)
      model.discount_price = this.m__calculate(price - (price * model.discount_percent / 100))
      model.error_message = ''
    },

    async m__model_enable_change(item, model) {
      if (model.discount_percent > 90 || model.discount_percent < 5) {
        model.error_message = this.$t('flash_sale.discount_percent_between_x_y', {
          x: '5',
          y: '90'
        })
        model.enable = false
        item.product.enable = false
        return
      }

      if (model.quantity < 1 || model.quantity > model.stock) {
        model.error_message = this.$t('flash_sale.promotion_quantity_between_x_y', {
          x: '1',
          Y: model.stock
        })
        model.enable = false
        item.product.enable = false
        return
      }

      if (model.quantity > 1000) {
        model.error_message = this.$t('flash_sale.promotion_quantity_lt_x', {x: '1000'})
        model.enable = false
        item.product.enable = false
        return
      }

      if (model.quantity * this.flash_sale_created.length > model.stock) {
        model.error_message = this.$t('flash_sale.evenly_every_days')
        model.enable = false
        item.product.enable = false
        return
      }

      if (model.enable) {
        model.error_message = ''
      }

      if (this.is_edit_component) {
        model.error_message = ''
        await this.m__save_and_apply()
      }
    },

    m__model_update_discount_price(item, model) {
      const price = this.price_type === 'original' ? model.price : (model.promotionPrice || model.price)
      if (model.discount_price > price) {
        model.discount_price = price
      }

      model.discount_percent = 100 - Math.ceil(model.discount_price * 100 / price)
      model.error_message = ''
    },

    async m__save_and_apply(ntf = false) {
      const form = {
        flash_sale_id: this.flash_sale.flash_sale_id,
        items: []
      }
      for (const item of this.product_selected_list) {
        // console.log('product', item.product)

        for (const model of item.model_list) {
          if (model.stock > 0) {
            form.items.push({
              item_id: item.product.itemid,
              model_id: model.modelid,
              input_promo_price: model.discount_price,
              purchase_limit: item.product.limit === 1 && item.product.limit_value ? item.product.limit_value : 0,
              status: model.enable ? 1 : 0,
              stock: +model.quantity,
              item_display_image: item.product.images.split(',')[0],
            })
          }
        }
      }

      // console.log(form)
      if (form.items.length) {
        const resp = await this.seller.flash_sale_save_batch_items(form)
        // console.log(resp)
        if (resp && resp.data && resp.data.failed_items) {
          for (const item of resp.data.failed_items) {
            const product_found = this.product_selected_list.find(i => i.product.itemid === item.item_id)
            if (product_found) {
              const model_found = product_found.model_list.find(i => i.modelid === item.model_id)
              if (model_found) {
                // product_found.product.enable = false
                // model_found.enable = false
                model_found.error_message = `${this.$t('flash_sale.api_error_response')}: ${item.err_msg}`
              }
            }
          }
        }

        if (resp && resp.data && resp.data.warning_items) {
          for (const item of resp.data.warning_items) {
            const product_found = this.product_selected_list.find(i => i.product.itemid === item.item_id)
            if (product_found) {
              const model_found = product_found.model_list.find(i => i.modelid === item.model_id)
              if (model_found) {
                // product_found.product.enable = false
                // model_found.enable = false
                model_found.error_message += `${this.$t('flash_sale.attention_when_create')}: ${item.err_msg}`
              }
            }
          }
        }

        this.save_and_apply_successfully = true
      }

      if (ntf) this.ntf_s(this.$t('flash_sale.updated_message'))
    },

    m__show_create_flash_sale_filename_dialog() {
      this.filename = ''
      this.show_dialog.create_flash_sale_filename = true
    },

    async m__create_flash_sale_file() {
      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }
      if (!this.product_selected_list.length) {
        this.ntf_w(this.$t('required.select_products'))
        return
      }
      // console.log(this.product_selected_list)

      const form = {
        mipeeUserId: this.$store.state.userInfo.username,
        filename: this.filename,
        products: this.product_selected_list.map(i => ({
          productId: i.product.itemid,
          models: JSON.stringify(i.model_list.map(ii => ({
            ...ii,
            enable: false,
            checked: false
          })))
        })),
        shopId: this.shop_id
      }

      try {
        this.loading.create_flash_sale_file = true
        await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale', form, this.cf())
        this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.save_success'))
        this.show_dialog.create_flash_sale_filename = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.create_flash_sale_file = false
      }
    },

    m__get_flash_sale_files() {
      this.$emit('m__get_flash_sale_files')
    }
  }
}
</script>

<style lang="scss">
.sticky-hide {
  display: none;
}

.sticky {
  display: block;
  position: fixed;
  top: 0;
  z-index: 999;

  p, br {
    display: none;
  }
}

.table > thead > tr > th {
  vertical-align: text-top !important;
}

.text-warning-level-1 {
  input {
    color: red !important;
  }
}

.text-warning-level-2 {
  input {
    color: orangered !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/flash_sale/component_product.vue